import React, { useEffect, useState } from 'react';

import { emitOrderUpdatedEvent } from './utils/events'

// WDCE-295: statuses reachable before a successful payment is reflected in the DB.
// paid/shipped are deliberately excluded so the summarycode override below doesn't
// mask an order that has already progressed past payment (e.g. a POS order the
// PAID -> SHIPPED webhook already processed) by the time the browser redirect lands.
//
// WDCE-295: this fix is intentionally landing ahead of Part 5. Do NOT deploy/push to
// staging until Part 5 (FoodTableOrder.jsx handling the 'shipped' status on the
// thank-you page) is also complete - otherwise a POS credit-card order that's already
// shipped by redirect time will incorrectly fall through to re-rendering the checkout
// form for the customer, since FoodTableOrder.jsx currently only branches on
// status == 'paid'.
const PRE_PAYMENT_STATUSES = [
  'cancelled', 'confirmed', 'inactive', 'not_confirmed', 'offered', 'on_hold',
  'ordered', 'pending', 'one_step_offered', 'eft_pending', 'table_open',
]

export const checkQuantity = (orderId, orderDetailId, quantity) => {
  const body = new FormData()

  body.append("quantity_check", "true")
  body.append(`order[order_details_attributes][${orderDetailId}][id]`, orderDetailId)
  body.append(`order[order_details_attributes][${orderDetailId}][quantity]`, quantity)

  return fetch(`/orders/${orderId}`, {
    body: body,
    method: "PATCH",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").getAttribute("content"),
    },
  }).then(response => response.json())
}

export default WrappedComponent => (props) => {
  const [order, setOrder] = useState({})
  const [awaitingResponse, setAwaitingResponse] = useState(false)

  useEffect(() => fetchOrder(), []);

  const fetchOrder = () => {
    let ignore = false;

    fetch(`${props.orderPath}.json`, {
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    }).then(response => response.json())
    .then(response => {
      // Overriding the order status based on the callback from the payment gateway,
      // but only while the order is still in a pre-payment state - otherwise this
      // would clobber a status the order has already progressed past.
      if (window.location.search.includes("summarycode=1") && PRE_PAYMENT_STATUSES.includes(response.order.status)) {
        response.order.status = 'paid'
      }

      if (!ignore) setOrder(response.order);
    });

    return () => { ignore = true; }
  }

  const updateOrder = ({ checkout = false, paymentType = null }) => {
    let body = new FormData(document.getElementById('order-form'))

    body.append("checkout", checkout);
    body.append("payment_type", paymentType);

    return fetch(props.orderPath, {
      body: body,
      method: "PATCH",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").getAttribute("content"),
      },
    })
    .then(response => response.json())
    .then(response => {
      if (response.order) {
        setOrder(response.order)
        emitOrderUpdatedEvent(response.order)
      } else if (response.errors.deleted_order_alert != null) {
        alert(response.errors.deleted_order_alert)
        window.open(`/`, '_self');
      } else {
        handleUnexpectedError("Unexpected error occurred while updating the order");
      }
      return response;
    });
  }

  const displayOrder = () => {
    if (Object.keys(order).length === 0) {
      return (<p className="text-center">Loading...</p>)
    } else {
      return (<WrappedComponent
        order={order}
        handleOrderUpdate={updateOrder}
        awaitingResponse={awaitingResponse}
        {...props}
      />);
    }
  }

  return displayOrder();
};
